<ng-container *ngIf="featureDisabled === false"
  ><span ngbDropdown="ngbDropdown">
    <button
      class="btn btn-sm"
      ngbDropdownToggle="ngbDropdownToggle"
      type="button"
    >
      {{ requestMethod || "All HTTP methods" }}
    </button>
    <ul
      class="dropdown-menu--reduced-padding"
      ngbDropdownMenu="ngbDropdownMenu"
    >
      <li *ngIf="requestMethod">
        <a (click)="deleteRequestMethod()" ngbDropdownItem="ngbDropdownItem"
          ><i
            class="list-icon glyphicon"
            [ngClass]="{ 'glyphicon-check': !requestMethod }"
          ></i
          >All HTTP methods</a
        >
      </li>
      <li *ngFor="let reqMethod of requestMethods; trackBy: trackByIndex">
        <a
          (click)="selectRequestMethod(reqMethod)"
          ngbDropdownItem="ngbDropdownItem"
          ><i
            class="list-icon glyphicon"
            [ngClass]="{ 'glyphicon-check': requestMethod === reqMethod }"
          ></i
          >{{ reqMethod }}</a
        >
      </li>
    </ul></span
  ></ng-container
>
